var map = {
	"./Captura de tela 2023-05-16 153334-fotor-bg-remover-20230516153425.png": "7bcb",
	"./Crop_logo_allstech.svg": "30db",
	"./Cópia de Alls Technology (1).jpg": "7339",
	"./Cópia de Alls Technology.jpg": "e654",
	"./My project copiar-1.png": "69b3",
	"./analise.svg": "8e05",
	"./ativos.svg": "11e8",
	"./basic.svg": "4e64",
	"./bitmap.svg": "fb9d",
	"./channels4_profile-removebg-preview.png": "76d2",
	"./channels4_profile-removebg.png": "2f9e",
	"./colete.svg": "2dfa",
	"./compilado-flexxs.svg": "0bf8",
	"./compilado-px40.svg": "8fdc",
	"./conecte.svg": "1f95",
	"./electric-motor.png": "1936",
	"./empresa_default.png": "e79f",
	"./equipe.svg": "b790",
	"./flexxs-celular.png": "0dc7",
	"./fundo-contact.jpg": "2fde",
	"./fundo-grid-allsTech.svg": "166b",
	"./fundo-solutions-teste.jpg": "4d3c",
	"./fundo-solutions.jpg": "c8d6",
	"./fundo-teste.jpg": "cc5f",
	"./fundo-teste.png": "3326",
	"./fundo.png": "3ce9",
	"./fundo2.png": "dab5",
	"./gif.svg": "f058",
	"./img01.png": "0fb6",
	"./img02.png": "5148",
	"./img03.png": "1584",
	"./instagram.png": "c7f8",
	"./logo.eps": "fc02",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logo2.png": "5fbe",
	"./logo_allstech.svg": "167d",
	"./logo_px40_branca.svg": "b2e9",
	"./logo_px40_clara.png": "3ea4",
	"./logo_px40_clara_B&W.png": "7d3b",
	"./logo_px40_clara_quadrada.png": "97ee",
	"./logo_px40_flutter.png": "b086",
	"./logo_px40_principal.png": "17ce",
	"./logoflexxs.png": "3f48",
	"./logoflexxs_B&W.png": "b5f8",
	"./mail.png": "5cb6",
	"./onda.png": "4891",
	"./optmization.png": "7ae0",
	"./pagina_inicial.svg": "1d03",
	"./px40-celular.png": "56f3",
	"./reports.svg": "97b9",
	"./sala14.png": "ba8a",
	"./servicos.svg": "6369",
	"./tomedecisoes.svg": "2c99",
	"./undraw_source_code_re_wd9m.svg": "45e5",
	"./whatsapp.png": "9673",
	"./worldwide.png": "a0b1",
	"./youtube.png": "e63a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";